import axios from 'axios'
import util from './index'
const rules = {
    userName: [
        { required: true, message: '登录账号为手机号'},
        { validator: 'regexp', pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'},
        { validator: checkUserName, trigger: 'blur'}
    ],
    loginName: [
        { required: true, message: '请输入登录账号'}
    ],
    verificationCode:[{ required: true, message: '请输入验证码'}],
    fpassword: [
        {required: true, message: '请输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    fenPassword: [
        {required: true, message: '请再次输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    registerStatusName: [
        {required: true}
    ],
    supplierStatusName: [
        {required: true}
    ],
    companyName: [
        { required: true, message: '请输入企业名称'}
    ],
    taxipayerStatus: [
        { required: true, message: '请选择纳税人状态', trigger: 'change'}
    ],
    // responser
   /* socialCreditCode:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[0-9a-zA-Z]{18}$/,trigger: 'blur' }
        ],
    businessLicenseNumber:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[a-zA-Z0-9]{13,15}$/,trigger: 'blur' }
        ],*/
    taxCertificateNumber:[
        {required: true, message: '请输入税务登记证号'}
        ],
    orgCertificateNumber:[
        {required: true, message: '请输入组织机构代码证号'}
        ],
    intentionRegionalCompanyIds:[
        {required: true, message: '请选择意向地区公司'}
    ],
    undertakeAreas: [
        {required: true, message: '请选择可承接省份'}
    ],
    supplierServiceCategoryIds:[
        {required: true, message: '请选择供方服务类别', trigger: 'change'}
    ],
    supplierCategoryIds:[
        {required: true, message: '请选择供方分类', trigger: 'change'}
    ],
    headquartersAddress:[
        {required: true, message: '请输入总部具体地址'}
    ],
    enterpriseCharacterize:[
        {required: true, message: '请选择企业性质'}
    ],
    enterpriseCharacterizeRemark:[
        {required: true, message: '请输入“其他”，相关说明'}
    ],
    enterpriseRegistAddress:[
        {required: true, message: '请输入企业注册地址'}
    ],
    enterpriseRegistrationYear:[
        {required: true, message: '请选择企业成立日期', trigger: 'change'},
    ],
    officeArea:[
        {validator: 'regexp', pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,message: '办公面积必须为数字值', trigger: 'blur'}
    ],
    legalRepresentative:[
        {required: true, message: '请输入法定代表人'}
    ],
    legalRepresentativeIdNumber:[
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确', trigger: 'blur'}
    ],
    registeredCapital:[
        {required: true, message: '请输入注册资本'},
        { type: 'number', message: '注册资本必须为数字值',trigger: 'blur'}
    ],
    qualificationName: [
        {required: true, message: '请输入资质名称'}
    ],
    certificateNumber:[
        {required: true, message: '请输入资质证书编号'}
    ],
    validityPeriod:[
        {required: true, message: '请选择资质证书有效期'}
    ],
    stockholderName:[
        {required: true, message: '请输入股东姓名'}
    ],
    stockholderCreditNumber:[
        {required: false, message: '请输入股东身份证号'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确',trigger: 'blur'}
    ],
    contactName:[
        {required: true, message: '请输入联系人姓名'}
    ],
    mobile:[
        {required: true, message: '请输入联系人手机'},
        { validator: 'regexp', pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    email:[
        {required: true, message: '请输入联系人电子邮件'},
        { validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
    ],
    creditNumber:[
        {required: false, message: '请输入联系人身份证号'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确', trigger: 'blur'}
    ],
    positionName:[
        {required: true, message: '请输入联系人职位'}
    ],
    recommenderType:[
        {required: true, message: '请选择推荐人类型'}
    ],
    recommenderName:[
        {required: true, message: '请输入推荐人'}
    ],
    recommenderUnit:[
        {required: true, message: '请输入推荐人单位'}
    ],
    recommenderPhone:[
        {required: true, message: '请输入推荐人联系电话'},
        { validator: 'regexp', pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    recommenderIllustration:[
        {required: true, message: '请输入推荐人说明'}
    ],
    hasRelateParentCompany: [
        { required: true, message: '请选择有无关联公司' }
    ],
    relateParentCompanyId:[
        {required: true, message: '请选择关联母公司名称'}
    ],
    mainBusinessAreaIds:[
        {required: true, message: '请输入主要业务区域'}
    ],
    lastYearSales:[
        {required: true, message: '请输入近年营业额'},
        { type: 'number', message: '营业额必须为数字值',trigger: 'blur'}
    ],
    fileList: [
        { required: true, message: '附件不能为空'}
    ],
    //新增字段：
    headquartersProvince:[//所在区域
        {required: true, message: '请选择所在区域',validator: checkArea}
    ],
    companyListed:[//是否上市公司
        {required: true, message: '请选择是否上市公司'}
    ],
    staffNumbers:[//员工总数
        {required: true, message: '请输入员工总数'},
        { type: 'number', message: '员工总数必须为数字值',trigger: 'blur'}
    ],
    fullMemberFlag:[//是否全装联会员
        {required: true, message: '请选择是否全装联会员'}
    ],
    cooperationAmount: [//合作额度
        { required: true,validator: checkDeg}
    ],
    accountNumber:[ // 收款账号
        {required: true, message: '请输入收款账号'},
        { pattern:/^[0-9]+$/, message: '收款账号必须为数字值',trigger: 'blur'}
    ],
    bankNumber:[ // 联行号
        {required: false, message: '请输入联行号'},
        { pattern:/^[0-9]+$/, message: '联行号必须为数字值',trigger: 'blur'}
    ],
    bankName:[ 
        {required: true, message: '请输入开户行',trigger:'blur'},
    ],
    accountType:[
        {required: true, message: '请选择开户行类型',trigger:'change'},
    ],
    businessYear:[ // 营业额年份
        {required: true, message: '请选择年份',trigger:'change'},
    ],
    businessVolume:[ // 营业额
        {required: true, message: '请输入营业额'},
        { pattern:/^[0-9]+$/, message: '营业额必须为数字值',trigger: 'blur'}
    ],
    businessScope:[ // 经营范围
        {required: true, message: '请输入经营范围'},
    ],
    businessYearLimitedStart:[ // 营业期限
        {type: 'string',required: true, message: '请选择营业期限',trigger:'change'},
    ],
    gradeLevel:[
        { required: true, message: '请输入级别',trigger:'blur'},
    ],
    acceptableScope:[
        { required: true, message: '请输入可承接范围',trigger:'blur'},
    ],
    avgAnnualCapacity:[ // 平均年产能
        { required: true, message: '请输入平均年产能',trigger:'blur'},
    ],
    processBaseAddress:[ // 加工基地地址
        { required: true, message: '请输入加工基地地址',trigger:'blur'},
    ],
    processBaseChargePerson:[ // 加工基地负责人
        { required: true, message: '请输入加工基地负责人',trigger:'blur'},
    ],
    processBaseContactMode:[ // 加工基地联系方式
        { required: true, message: '请输入加工基地联系方式',trigger:'blur'},
    ],
    processBaseScale:[ // 加工基地规模
        { required: true, message: '请输入加工基地规模',trigger:'blur'},
    ],
    processBaseEquipment:[ // 加工基地设备
        { required: true, message: '请输入加工基地设备',trigger:'blur'},
    ],
    technicalAbility:[ // 公司技术力量
        { required: true, message: '请输入公司技术力量',trigger:'blur'},
    ],
    laborForceOrg:[ // 公司劳动力组织
        { required: true, message: '请输入公司劳动力组织',trigger:'blur'},
    ],
    cooperativeUnitName:[
        { required: true, message: '请输入合作单位名称',trigger:'blur'},
    ],
    cooperativeCategoryName:[
        { required: true, message: '请输入合作类别',trigger:'blur'},
    ],
    cooperativeStartTime:[
        { type:'string' , required: true, message: '请输入合作开始时间',trigger:'change'},
    ],
    cooperativeEndTime:[
        { type:'string' , required: true, message: '请输入合作结束时间',trigger:'change'},
    ],
    cooperativeAreaName:[
        { required: true, message: '请输入合作区域',trigger:'blur'},
    ],
    lstattachmentVO:[
        { required: true, message: '请选择合同附件',trigger:'blur'},
    ],
    cooperativeProjectName:[
        { required: true, message: '请输入合作项目',trigger:'blur'},
    ],
    cooperationScope:[
        { required: true, message: '请输入合作范围',trigger:'blur'},
    ],
    cooperativeProjectScale:[
        { required: true, message: '请输入项目规模',trigger:'blur'},
    ],
    supplyModeMore:[ // 供货模式
        {required: true, message: '请输入供货品牌', trigger: 'blur'},
    ],
    supplyMode:[ // 供货模式
        {required: true, message: '请选择供货模式', trigger: 'change'},
    ]





};
function checkUserName(rule,value,callback){
    axios.get(util.baseUrl+'/v1/sSuppliers/public/checkLoginName/'+value+'/1')
        .then(function (res) {
            // console.log(res);
            if(res.data.code == 1){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
function checkArea(rule,value,callback){
    // console.log(value)
    if(value == ''){
        callback(new Error('请选择所在区域'));
    } else {
        callback();
    }
}
function checkDeg(rule,value,callback){
    // console.log(value)
    // let reg = /^(-?\d+)(\.\d+)?$/;
    let reg = /^\d+(\.\d{1,2})?$/;
    if(!value){
        callback(new Error('请输入合作额度'));
    } else if(!reg.test(value)) {
        callback(new Error('请输入数字，且小数点后不超过两位'));
    } else {
        callback();
    }
}
/*function checkSocialCode(rule,value,callback){

    axios.post(util.baseUrl+'/v1/sSuppliers/public/checkCodeOrNumber',{
        "businessLicenseNumber": "",
        "creditLicenseCodeFlag": 1,
        "socialCreditCode": value,
        "supplierId": ''
    })
        .then(function (res) {
            console.log(res);
            if(res.data.code == 2){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}*/

let registerRules = {}//注册页面注册信息及企业信息验证
__rules_generator(registerRules, ['userName','verificationCode','fpassword','fenPassword','companyName','taxipayerStatus','taxCertificateNumber','orgCertificateNumber','intentionRegionalCompanyIds','supplierServiceCategoryIds','supplierCategoryIds','headquartersAddress','enterpriseCharacterize','enterpriseCharacterizeRemark','enterpriseRegistAddress','enterpriseRegistrationYear','officeArea','legalRepresentative','legalRepresentativeIdNumber','registeredCapital','registerStatusName','supplierStatusName','headquartersProvince','companyListed','staffNumbers','fullMemberFlag','undertakeAreas','businessScope','businessYearLimitedStart','supplyModeMore','supplyMode'], rules)
let naturalRules = {}//资质等级验证
__rules_generator(naturalRules, ['qualificationName','certificateNumber','validityPeriod','gradeLevel','acceptableScope'], rules)
let partnerRules = {}//股东验证
__rules_generator(partnerRules, ['stockholderName','stockholderCreditNumber'], rules)
let contactRules = {}//联系方式验证
__rules_generator(contactRules, ['contactName','mobile','email','creditNumber','positionName'], rules)
let InfoTypeRules = {}//信息类型验证
__rules_generator(InfoTypeRules, ['recommenderType','recommenderName','recommenderUnit','recommenderPhone','recommenderIllustration'], rules)
let affiliateRules = {}//关联母公司验证
__rules_generator(affiliateRules, ['hasRelateParentCompany','relateParentCompanyId'], rules)
let businessRules = {}//业务状况验证
__rules_generator(businessRules, ['mainBusinessAreaIds','lastYearSales','avgAnnualCapacity','processBaseAddress','processBaseChargePerson','processBaseContactMode','processBaseScale','processBaseEquipment','technicalAbility','laborForceOrg'], rules)
let numberRules = {}//近三年业绩验证
__rules_generator(numberRules, ['cooperationAmount','cooperativeUnitName','cooperativeCategoryName','cooperativeStartTime','cooperativeEndTime','cooperativeAreaName','lstattachmentVO','cooperativeProjectName','cooperativeProjectScale','cooperationScope'], rules)
let annexRules = {}//附件清單
__rules_generator(annexRules, ['fileList'], rules)
let loginRules = {};//登录界面验证
__rules_generator(loginRules, ['loginName','verificationCode','fpassword'], rules)
let bankRules = {}; // 银行信息
__rules_generator(bankRules, ['accountType','bankName','accountNumber','bankNumber'], rules)
let baseBusinessInfoRules  = {}; // 营业额信息
__rules_generator(baseBusinessInfoRules, ['businessYear','businessVolume'], rules)

export {
    registerRules,
    naturalRules,
    partnerRules,
    contactRules,
    InfoTypeRules,
    affiliateRules,
    businessRules,
    numberRules,
    annexRules,
    loginRules,
    bankRules,
    baseBusinessInfoRules
}

function __rules_generator(obj, keys, rules){
    keys.forEach(k=>{
        return obj[k] = rules[k]
    })
}



// WEBPACK FOOTER //
// ./src/util/rules.js